export default "__VITE_PUBLIC_ASSET__ba58c397__"